import { useSelector } from 'react-redux'

import SplashScreen from './components/SplashScreen/SplashScreen'
import Progress from './components/Progress/Progress'
import Subtitles from './components/Subtitles/Subtitles'
import End from './components/End/End'
import Tutorial from './components/Tutorial/Tutorial'

import './Interface.scss'

export default function Interface() {
  // TODO - Provide these in a context ?
  const { currentIndex, mode, items } = useSelector((state) => state.progress)

  return (
    <>
      <SplashScreen />
      <Tutorial />
      <div
        className={`c-interface ${mode === 'inspection' ? '-is-active' : ''}`}
      >
        {/* TODO - Remove this later with the use of a context */}
        <End currentIndex={currentIndex} mode={mode} items={items} />
        <Subtitles currentIndex={currentIndex} mode={mode} />
        <Progress currentIndex={currentIndex} mode={mode} />
      </div>
    </>
  )
}
